// ── 生成流程紀錄 API（圖片庫「繼續生成」用） ──────────────────────────────────

import { apiFetch, API_BASE_URL } from './client';

/** 該段流程產出的單張圖片。已刪除者只留佔位資訊，位置不變。 */
export interface RestoredSessionImage {
  index: number;
  deleted: boolean;
  fileId?: string;
  gcsPath?: string;
  imageUrl?: string;
}

/** 還原對話面板用的訊息 */
export interface RestoredChatMessage {
  role: 'user' | 'model';
  content: string;
  timestamp: string;
}

export interface RestoredReferenceImage {
  questionId: string;
  fileId: string;
  gcsPath: string;
  /** 還原當下重新簽發的 URL */
  url: string;
}

export interface RestoredSession {
  id: string;
  flowModelId?: string;
  answers: Record<string, string | boolean>;
  /** 對應不到現存題目、未被套用的答案 */
  orphanedAnswers: { questionId: string; value: string | boolean }[];
  /** 當初使用的工具包已不存在（與「題目被改過」是兩回事） */
  toolkitMissing: boolean;
  /** 工具包題目自當初以來被改過 */
  toolkitChanged: boolean;
  additionalRequirements?: string;
  images: RestoredSessionImage[];
  /** 這段流程使用的 AI 對話 id；沒用過對話時為 undefined */
  chatSessionId?: string;
  /** 該段對話的訊息，用來重建對話面板；沒有對話時是空陣列 */
  chatMessages: RestoredChatMessage[];
  referenceImages: RestoredReferenceImage[];
  /** 題目 id → fileId[]，重新生成時原樣送回後端 */
  imageAnswers: Record<string, string[]>;
  createdAt: string;
  updatedAt: string;
}

export const fetchGenerationSession = async (sessionId: string): Promise<RestoredSession> => {
  const res = await apiFetch(`${API_BASE_URL}/generation-sessions/${sessionId}`);
  if (!res.ok) throw new Error('Failed to fetch generation session');
  return res.json();
};
